import type { LoadedFspValues } from "@fero/hooks";
import type { TableBodyProps } from "@mui/material";
import type { StockListing } from "adl-gen/ferovinum/app/api";
import type { Currency } from "adl-gen/ferovinum/app/db";
import { assertNotUndefined } from "utils/hx/util/types";
import { loading } from "utils/utility-types";
import { ProductRow } from "../product-row";

interface Props extends TableBodyProps {
  rows: { code: string; listings: StockListing[] }[];
  fspValuesMap: Record<string, LoadedFspValues>;
  currency: Currency;
}

export const StockListingTableBody = ({
  rows,
  fspValuesMap,
  currency,
}: Props) => {
  return (
    <>
      {rows.map((row) => {
        const listings = assertNotUndefined(row.listings);
        const product = listings[0].product;
        const fspValues = fspValuesMap[row.code] ?? loading();
        return (
          fspValues && (
            <ProductRow
              key={row.code}
              currency={currency}
              fspValues={fspValues}
              productWithId={product}
              productDealLegs={listings.map((sl) => sl.productDealLeg)}
            />
          )
        );
      })}
    </>
  );
};
